export enum AccountTabType {
    Profile = 0,
    Business = 1,
    Farms = 2,
}